import styled from "styled-components";
import { Box, Typography } from "@material-ui/core";

export const ResultContainer = styled.div`
  margin-left: 12.5%;
  max-width: 60em;
`;

export const Table = styled(Box)`
  && {
    max-width: 60em;
    height: 30rem;
    border-radius: 1%;
    overflow: auto;
  }
`;

export const Action = styled.button`
  && {
    background-color: ${props => (props.bgColor ? props.bgColor : "none")};
    height: 3em;
    border-radius: 7px;
    border: none;
    color: white;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px 10px;
    outline: none;
  }
`;

export const Status = styled.span`
  color: ${props => (props.color ? props.color : "none")};
  font-size: 1em;
`;

export const RowTable = styled(Typography)`
  && {
    padding: 18px 0px 10px 0px;
    font-size: 22px;
    font-weight: ${props => (props.fontWeight ? props.fontWeight : "100")};
    font-size: 20px;
  }
`;

export const ResultBox = styled(Box)`
  && {
    background-color: white;
    margin: 20px 20px 20px 0px;
    padding: 20px;
    @media (max-width: 600px) {
      margin: 0px 10px;
    }
  }
`;
